<template>
  <v-dialog v-model="show" persistent scrollable max-width="700">
    <v-card>
      <v-card-title class="mb-5 w-100">
        <h2>{{ task.title }}</h2>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog" large color="error">
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card-text class="pt-5 m-5">
        <v-checkbox v-model="task.need_confirm"
                    class="my-10"
                    aria-required="true" label="نیاز به تایید دارد؟"
                    rounded outlined
                    style="border-radius: 5px"
        ></v-checkbox>
        <v-text-field
            v-model="task.confirm_mobile_number"
            aria-required="true"
            label="شماره تماس تایید کننده"
            rounded
            outlined
            style="border-radius: 5px"
            :rules="[rules.required, rules.min_3, rules.validMobile]"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn
            color="green"
            class="mr-auto mb-1 ml-1"
            block
            @click="updateConfirm"
            :loading="loading"
        >
          ثبت
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "ConfirmTask",
  props: ["show", "task"],
  data: () => ({
    key: localStorage.getItem("key"),
    loading: false,
    rules: {
      validMobile:(value) =>
          /^09\d{9}$/.test(value) || "شماره موبایل معتبر نیست (باید با 09 شروع شود و 11 رقم باشد).",
      required: (value) => !!value || "این فیلد الزامی است.",
      min_3: (value) =>
          (value && value.length >= 3) || "حداقل باید ۳ کاراکتر باشد.",
    },
  }),
  methods: {
    closeDialog() {
      this.show = false;
      this.$emit("close");
    },
    async updateConfirm() {
      if (!this.task.confirm_mobile_number) {
        this.$emit("error", "لطفاً شماره تماس تایید کننده را وارد کنید.");
        return;
      }

      this.loading = true;

      try {
        const response = await axios.put(
            `${this.BACKEND_LINK}/api/tasks/update-confirm/${this.task.id}`,
            { need_confirm: this.task.need_confirm, confirm_mobile_number: this.task.confirm_mobile_number },
            {
              headers: {
                Authorization: `Token ${this.key}`,
              },
            }
        );

        if (response.data.status) {
          this.$emit("success", response.data.msg);
          this.closeDialog();
        } else {
          this.$emit("error", response.data.msg || "خطایی رخ داده است.");
        }
      } catch (error) {
        this.$emit(
            "error",
            error.response?.data?.msg || "خطا در ارتباط با سرور رخ داده است."
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
